import { OnInit, Renderer2, OnDestroy, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardService } from '../../dashboard';
import { ErrorHandlerService } from '../../services';
import { LoginService } from '../../login';
import * as moment from 'moment';
// import { Ng2ImgMaxService } from 'ng2-img-max';
import { ImageCropperComponent, CropperSettings } from 'ng2-img-cropper';
import { ElementRef, QueryList } from '@angular/core';
var timestamp = moment(new Date()).format('DDMMYYYYhhmmss').toString() + moment.tz.zone(Intl.DateTimeFormat().resolvedOptions().timeZone.toString()).abbr(360);
var EditProfileComponent = /** @class */ (function () {
    function EditProfileComponent(userService, dashboardService, errorHandlerService, loginService, router, _renderer2) {
        this.userService = userService;
        this.dashboardService = dashboardService;
        this.errorHandlerService = errorHandlerService;
        this.loginService = loginService;
        this.router = router;
        this._renderer2 = _renderer2;
        this.insertImageSettings = {
            saveUrl: process.env.API_URL + "/session/inlineimage?timestamp=" + timestamp + "&jwtToken=" + localStorage.getItem('authorization'),
            path: process.env.COURSE_IMAGE_URL + this.dashboardService.userdata.userDetailsId + timestamp + "/"
        };
        this.tools = {
            items: ['Undo', 'Redo', '|',
                'Bold', 'Italic', 'Underline', 'StrikeThrough', '|',
                'FontName', 'FontSize', 'FontColor', 'BackgroundColor', '|',
                'SubScript', 'SuperScript', '|',
                'LowerCase', 'UpperCase', '|',
                'Formats', 'Alignments', '|', 'OrderedList', 'UnorderedList', '|',
                'Indent', 'Outdent', '|', 'CreateLink',
                'Image', '|', 'ClearFormat', 'Print', 'SourceCode', '|', 'FullScreen']
        };
        this.academicProf = true;
        this.personalProf = true;
        this.professionalProf = false;
        this.myRating = [];
        this.profileImgLoader = false;
        // edit : number = 0;
        this.cir = [];
        this.allcir = [];
        this.courseiRcmd = [];
        this.eduqloading = false;
        this.CorseIR = false;
        this.profileclg = false;
        this.degreeedit = false;
        this.linkedInProfileedit = false;
        this.pastedu = false;
        this.aboutme = false;
        this.skills = false;
        this.interest = false;
        this.userRcmdloading = false;
        this.degreeloading = false;
        this.linkedInProfileloading = false;
        this.pastloading = false;
        this.aboutloading = false;
        this.addwrkexploading = false;
        this.interestloading = false;
        this.viewProfile = {};
        this.user = {};
        this.updateeducationalQualification = {};
        this.updatedegreeCourse = {};
        this.updatelinkedInProfile = {};
        this.addpastEducation = {};
        this.editAboutMe = {};
        this.myInterest = {};
        this.eduInstresults = [];
        this.userTyperesults = [];
        this.courseIRresults = [];
        this.userTypes = [];
        this.CoursesIRcmd = [];
        this.allskills = [];
        this.skillsdata = [];
        this.getSkills = [];
        this.wrkExp = { projectResearchDescription: "" };
        this.allwrkExp = [];
        this.allpastEdu = [];
        this.editWorkexps = [];
        this.editWorkexp = {};
        this.updatePastEdudata = {};
        this.coursebyMe = [];
        this.userRcmd = [];
        this.updateusrrcmd = [];
        this.ts = new Date();
        this.present = true;
        this.wspresent = true;
        this.isPresent = false;
        this.wsisPresent = false;
        this.project = true;
        this.ImgeCroper = false;
        this.msgTitle = "";
        this.msgContent = "";
        this.popUp = false;
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorModalDialog = false;
        this.showErrorMessages = [""];
        this.showErrorMessageTitle = "Error!";
        this.showErrorMessageWidthInPercentage = "20%";
        this.subscriptions = [];
        this.isSessionExpired = false;
        this.userTypeDone = false;
        this.userSummaryDone = false;
        this.editViewProfileDone = false;
        this.skillsDone = false;
        this.workExpDone = false;
        this.cirDone = false;
        this.pastEduDone = false;
        this.cbmDone = false;
        this.uarDone = false;
        this.latestWorkExp = [];
        this.leader = true;
        this.profEdit = true;
        this.academicEdit = false;
        this.isWorkExpDataAvailable = false;
        this.initialProfileType = '';
        this.userProfileType = '';
        this.isProfileTypeChangeRequiredAfterProjResExpAdd = false;
        this.isProfileTypeChangeRequiredAfterAcademicUserTypeAdd = false;
        this.isAcademicUserTypeDataAvailable = true;
        this._user = {};
        this.userAddresses = { countryTO: {} };
        this.userAddresss = [{}];
        this.userSubType = {};
        this.userEducation = {};
        this.countries = [];
        this.workExpStartDateStartMonth = "";
        this.workExpStartDateStartMonthLabel = "";
        this.fromYear1 = "";
        this.workExpEndDateStartMonth = "";
        this.workExpEndDateStartMonthLabel = "";
        this.toYear1 = "";
        this.usertyperesults = [];
        this.cityresults = [];
        this.selectedCountryId = -1;
        this.selectedStateId = -1;
        this.stateIdNameMap = {};
        //cityIdNameMap: any = {};
        this.time_zone = "";
        this.loading = false;
        this.isValidationError = false;
        this.isCorporateUser = true;
        this.openStep2Popup = false;
        this.fromMonthCal = false;
        this.toMonthCal = false;
        this.countryId = null;
        this.city = "";
        this.signUpTwoData = null;
        this.cropperSettings = new CropperSettings();
        //this.cropperSettings.noFileInput = true;
        this.cropperSettings.width = 230;
        this.cropperSettings.height = 230;
        //this.cropperSettings.compressRatio = 0.30;
        this.cropperSettings.croppedWidth = 600;
        this.cropperSettings.croppedHeight = 600;
        this.cropperSettings.canvasWidth = 250;
        this.cropperSettings.canvasHeight = 250;
        this.cropperSettings.fileType = "image/jpeg";
        //this.cropperSettings.minWithRelativeToResolution = false;
        //this.cropperSettings.preserveSize = true;
        this.data = {};
        this.frommonths = [];
        this.frommonths.push({ label: 'From Month', value: null });
        this.frommonths.push({ label: 'Jan', value: '01' });
        this.frommonths.push({ label: 'Feb', value: '02' });
        this.frommonths.push({ label: 'Mar', value: '03' });
        this.frommonths.push({ label: 'Apr', value: '04' });
        this.frommonths.push({ label: 'May', value: '05' });
        this.frommonths.push({ label: 'June', value: '06' });
        this.frommonths.push({ label: 'July', value: '07' });
        this.frommonths.push({ label: 'Aug', value: '08' });
        this.frommonths.push({ label: 'Sept', value: '09' });
        this.frommonths.push({ label: 'Oct', value: '10' });
        this.frommonths.push({ label: 'Nov', value: '11' });
        this.frommonths.push({ label: 'Dec', value: '12' });
        this.tomonths = [];
        this.tomonths.push({ label: 'To Month', value: null });
        this.tomonths.push({ label: 'Jan', value: '01' });
        this.tomonths.push({ label: 'Feb', value: '02' });
        this.tomonths.push({ label: 'Mar', value: '03' });
        this.tomonths.push({ label: 'Apr', value: '04' });
        this.tomonths.push({ label: 'May', value: '05' });
        this.tomonths.push({ label: 'June', value: '06' });
        this.tomonths.push({ label: 'July', value: '07' });
        this.tomonths.push({ label: 'Aug', value: '08' });
        this.tomonths.push({ label: 'Sept', value: '09' });
        this.tomonths.push({ label: 'Oct', value: '10' });
        this.tomonths.push({ label: 'Nov', value: '11' });
        this.tomonths.push({ label: 'Dec', value: '12' });
    }
    EditProfileComponent.prototype.search = function (event) {
        this.results = ['Student', 'Professor'];
    };
    EditProfileComponent.prototype.updateImage = function (data) {
        var _this = this;
        this.showSpinner = true;
        var date = new Date();
        console.log(data);
        var blob = this.dataURItoBlob(data.image);
        var formData = new FormData(document.forms[0]);
        formData.append("profilepic", blob);
        var s1 = this.dashboardService.uploadImage(formData)
            .subscribe(function (data) {
            console.log(data);
            _this.viewProfile.profilePicName = data;
            _this.ts = date;
            _this.showSpinner = false;
            _this.data = {};
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s1);
        this.ImgeCroper = false;
    };
    // imageOnChange(event) {
    //     let date =  new Date();
    //     //this.profileImgLoader = true;
    //     var image:any = new Image();
    //     var file:File = event.target.files[0];
    //     var myReader:FileReader = new FileReader();
    //     var that = this;
    //     myReader.onloadend = function (loadEvent:any) {
    //         image.src = loadEvent.target.result;
    //         that.cropper.setImage(image);
    //     };
    //     myReader.readAsDataURL(file);
    //     this.ImgeCroper = true;
    //     // let date =  new Date();
    //     // let image = event.target.files[0];
    //     // this.ng2ImgMax.compressImage(image, 1.075).subscribe(
    //     //   result => {
    //     //     console.log(result);
    //     //     this.uploadedImage = new File([result], result.name);
    //     //     console.log(this.uploadedImage);
    //     //     let formData:FormData = new FormData();
    //     //     formData.append('profilepic', result, result.name);
    //     //     this.dashboardService.uploadImage(formData)
    //     //       .subscribe(
    //     //           data => {console.log(data); this.viewProfile.profilePicName = this.viewProfile.profilePicName+'?t='+date;
    //     //           this.profileImgLoader = false;
    //     //         },
    //     //           error=>{console.log(error);});
    //     //   },
    //     //   error => {
    //     //     console.log('😢 Oh no!', error);
    //     //   }
    //     // );
    //     // let date =  new Date();
    //     // let fileList: FileList = event.target.files;
    //     // console.log(fileList);
    //     // if(fileList.length > 0) {
    //     //     let file: File = fileList[0];
    //     //     let formData:FormData = new FormData();
    //     //     formData.append('profilepic', file, file.name);
    //     //     this.dashboardService.uploadImage(formData)
    //     //       .subscribe(
    //     //           data => {console.log(data); this.viewProfile.profilePicName = this.viewProfile.profilePicName+'?t='+date
    //     //         },
    //     //           ErrorHandler.handelError);
    //     // }
    // }
    EditProfileComponent.prototype.dataURItoBlob = function (dataURI) {
        var binary = atob(dataURI.split(',')[1]);
        var array = [];
        for (var i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i));
        }
        return new Blob([new Uint8Array(array)], { type: 'image/jpeg' });
    };
    EditProfileComponent.prototype.presentChange = function (e) {
        if (e.target.checked) {
            this.present = false;
            this.addpastEducation.isPresent = "T";
        }
        else {
            this.present = true;
            this.addpastEducation.isPresent = "F";
        }
    };
    EditProfileComponent.prototype.wschangePresent = function (e) {
        if (e.target.checked) {
            this.wspresent = false;
            this.wrkExp.isPresent = "T";
        }
        else {
            this.wspresent = true;
            this.wrkExp.isPresent = "F";
        }
    };
    EditProfileComponent.prototype.presentwsChange = function (e, data) {
        if (e.target.checked) {
            console.log(data);
            data.wspresent = false;
            data.editValue.isPresent = "T";
        }
        else {
            data.wspresent = true;
            data.editValue.isPresent = "F";
        }
    };
    EditProfileComponent.prototype.searchusertype = function (event) {
        this.userTyperesults = this.filterusertype(event.query, this.userTypes);
    };
    EditProfileComponent.prototype.filterusertype = function (query, usertypes) {
        console.log('query', query);
        console.log('usertypes', usertypes);
        //in a real application, make a request to a remote url with the query and return filtered results, for demo we filter at client side
        var filtered = [];
        for (var i = 0; i < usertypes.length; i++) {
            var usertyp = usertypes[i];
            if (usertyp.userSubTypeMaster.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                filtered.push(usertyp.userSubTypeMaster);
            }
        }
        console.log('filtered', filtered);
        return filtered;
    };
    EditProfileComponent.prototype.skillsinput = function () {
        var _this = this;
        // this.skillloading = true;
        this.skillsdata = [];
        this.allskills.forEach(function (val, ind, arr) {
            _this.skillsdata.push({ userSkillSetName: val });
        });
        // console.log(this.skillsdata);
        this.getSkills = this.skillsdata;
        var s2 = this.dashboardService.addSkills(this.skillsdata)
            .subscribe(function (data) {
            _this.skills = false;
            console.log(data);
            _this.getSkills = _this.skillsdata;
            // this.getSkills.forEach((val,ind,arr)=>{
            //   this.allskills.push(val.userSkillSetName);
            // });
            // console.log('success');
            //   console.log(this.allskills);
            // this.eduqloading = false;
        }, function (error) {
            _this.handleError(error);
            _this.skills = false;
        });
        this.subscriptions.push(s2);
    };
    EditProfileComponent.prototype.saveeducationalQualification = function () {
        var _this = this;
        //this.eduqloading = true;
        this.showSpinner = true;
        console.log(this.updateeducationalQualification);
        console.log('In saveeducationalQualification:');
        console.log('this.isProfileTypeChangeRequiredAfterAcademicUserTypeAdd==>' + this.isProfileTypeChangeRequiredAfterAcademicUserTypeAdd);
        console.log('this.isAcademicUserTypeDataAvailable==>' + this.isAcademicUserTypeDataAvailable);
        if (this.isProfileTypeChangeRequiredAfterAcademicUserTypeAdd == true) {
            console.log('In saveeducationalQualification: REST call succeeded: Before call to changeProfileType');
            console.log('this.isProfileTypeChangeRequiredAfterAcademicUserTypeAdd==>' + this.isProfileTypeChangeRequiredAfterAcademicUserTypeAdd);
            console.log('this.isAcademicUserTypeDataAvailable==>' + this.isAcademicUserTypeDataAvailable);
            this.updateeducationalQualification.profileType = this.userProfileType;
            var s3_1 = this.dashboardService.updateUserProfileTypeAndEducationalQualification(this.updateeducationalQualification)
                .subscribe(function (data) {
                console.log('');
                _this.showSpinner = false;
                _this.viewProfile = data;
                _this.profileclg = false;
                _this.isProfileTypeChangeRequiredAfterAcademicUserTypeAdd = false;
                _this.isAcademicUserTypeDataAvailable = true;
                console.log('In saveeducationalQualification: REST call to profileTypeEducationalQualification succeeded:');
                console.log('this.isProfileTypeChangeRequiredAfterAcademicUserTypeAdd==>' + _this.isProfileTypeChangeRequiredAfterAcademicUserTypeAdd);
                console.log('this.isAcademicUserTypeDataAvailable==>' + _this.isAcademicUserTypeDataAvailable);
                _this.createInfoAlert('User Profile Type Changed Successfully!!');
            }, function (error) {
                _this.showSpinner = false;
                _this.handleError(error);
                _this.skills = false;
            });
            this.subscriptions.push(s3_1);
        }
        else {
            var s3 = this.dashboardService.educationalQualification(this.updateeducationalQualification)
                .subscribe(function (data) {
                console.log('');
                _this.showSpinner = false;
                _this.viewProfile = data;
                _this.profileclg = false;
            }, function (error) {
                _this.showSpinner = false;
                _this.handleError(error);
                _this.skills = false;
            });
            this.subscriptions.push(s3);
        }
    };
    EditProfileComponent.prototype.cancelEducationalQualification = function () {
        this.profileclg = false;
        if (this.isProfileTypeChangeRequiredAfterAcademicUserTypeAdd == true) {
            this.isProfileTypeChangeRequiredAfterAcademicUserTypeAdd = false;
            this.userProfileType = 'Professional';
            this.createInfoAlert("Unable to change the profile type to 'Academic'.");
        }
    };
    EditProfileComponent.prototype.editdegreeCourse = function () {
        var _this = this;
        this.degreeloading = true;
        console.log(this.updatedegreeCourse);
        var s4 = this.dashboardService.degreeCourse(this.updatedegreeCourse)
            .subscribe(function (data) { _this.viewProfile = data; _this.degreeloading = false; _this.degreeedit = false; }, function (error) {
            _this.handleError(error);
            _this.skills = false;
        });
        this.subscriptions.push(s4);
    };
    EditProfileComponent.prototype.addhttp = function (url) {
        if (!/^(?:f|ht)tps?\:\/\//.test(url)) {
            url = "http://" + url;
        }
        return url;
    };
    EditProfileComponent.prototype.editlinkedInProfile = function () {
        var _this = this;
        this.linkedInProfileloading = true;
        console.log(this.updatelinkedInProfile);
        var s4 = this.dashboardService.linkedInProfile(this.updatelinkedInProfile)
            .subscribe(function (data) { _this.viewProfile = data; _this.linkedInProfileloading = false; _this.linkedInProfileedit = false; }, function (error) {
            _this.handleError(error);
            _this.skills = false;
        });
        this.subscriptions.push(s4);
    };
    EditProfileComponent.prototype.editpastEducation = function () {
        var _this = this;
        this.showSpinner = true;
        // console.log(this.addpastEducation.fromMonth+'-'+this.addpastEducation.fromYear);
        this.addpastEducation.educationStartDate = this.addpastEducation.fromMonth + '/01/' + this.addpastEducation.fromYear;
        if (this.present == true) {
            this.addpastEducation.educationEndDate = this.addpastEducation.toMonth + '/01/' + this.addpastEducation.toYear;
        }
        else {
            this.addpastEducation.educationEndDate = moment(this.ts).format('MM/DD/YYYY').toString();
        }
        console.log(this.addpastEducation);
        var s5 = this.dashboardService.addpastEducation(this.addpastEducation)
            .subscribe(function (data) {
            console.log(data);
            _this.allpastEdu = data;
            _this.pastloading = false;
            _this.pastedu = false;
            _this.showSpinner = false;
            _this.addpastEducation = {};
        }, function (error) {
            _this.showSpinner = false;
            //this.addpastEducation = {};
            _this.handleError(error);
            _this.skills = false;
        });
        this.subscriptions.push(s5);
    };
    EditProfileComponent.prototype.resetpastEdu = function () {
        this.isPresent = false;
        this.addpastEducation = { fromMonth: null, toMonth: null, isPresent: "F" };
    };
    EditProfileComponent.prototype.editaboutMe = function () {
        var _this = this;
        this.aboutloading = true;
        var s6 = this.dashboardService.editAboutMe(this.editAboutMe)
            .subscribe(function (data) { _this.viewProfile = data; _this.aboutloading = false; _this.aboutme = false; }, function (error) {
            _this.handleError(error);
            _this.skills = false;
        });
        this.subscriptions.push(s6);
    };
    EditProfileComponent.prototype.cancelNewWrkExp = function () {
        this.project = false;
        if (this.isProfileTypeChangeRequiredAfterProjResExpAdd == true) {
            this.isProfileTypeChangeRequiredAfterProjResExpAdd = false;
            this.userProfileType = 'Academic';
            this.createInfoAlert("Unable to change the profile type to 'Professional'.");
        }
    };
    EditProfileComponent.prototype.addNewWrkExp = function () {
        var _this = this;
        if (this.wrkExp.fromMonth == '' || this.wrkExp.fromYear == '' || this.wrkExp.fromMonth == undefined || this.wrkExp.fromYear == undefined) {
            alert('Please Select Start Date');
        }
        else {
            this.showSpinner = true;
            this.wrkExp.projectResearchStartDate = this.wrkExp.fromMonth + '/01' + '/' + this.wrkExp.fromYear;
            if (this.wrkExp.isPresent != "T") {
                this.wrkExp.projectResearchEndDate = this.wrkExp.toMonth + '/01' + '/' + this.wrkExp.toYear;
            }
            else {
                this.wrkExp.projectResearchEndDate = moment(this.ts).format('MM/DD/YYYY').toString();
            }
            console.log(this.wrkExp);
            var s7 = this.dashboardService.addWorkExp(this.wrkExp)
                .subscribe(function (data) {
                _this.allwrkExp = [];
                _this.addwrkexploading = false;
                console.log(data);
                data.forEach(function (element) {
                    element.editValue = {};
                    if (element.isPresent == 'T') {
                        element.wsisPresent = true;
                        element.wspresent = false;
                    }
                    else {
                        element.wsisPresent = false;
                        element.wspresent = true;
                    }
                    _this.allwrkExp.push(element);
                    _this.project = false;
                });
                if (_this.allwrkExp.length > 0) {
                    _this.isWorkExpDataAvailable = true;
                }
                else {
                    _this.isWorkExpDataAvailable = false;
                }
                if (_this.isProfileTypeChangeRequiredAfterProjResExpAdd == true) {
                    _this.changeProfileType(_this.userProfileType);
                    _this.isProfileTypeChangeRequiredAfterProjResExpAdd = false;
                }
                _this.showSpinner = false;
            }, function (error) {
                _this.showSpinner = false;
                _this.handleError(error);
                _this.skills = false;
            });
            this.subscriptions.push(s7);
        }
    };
    EditProfileComponent.prototype.editmyInterest = function () {
        var _this = this;
        this.showSpinner = true;
        var s8 = this.dashboardService.myInterest(this.myInterest)
            .subscribe(function (data) {
            _this.viewProfile = data;
            _this.interestloading = false;
            _this.interest = false;
            _this.showSpinner = false;
        }, function (error) {
            _this.showSpinner = false;
            _this.handleError(error);
            _this.skills = false;
        });
        this.subscriptions.push(s8);
    };
    EditProfileComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    EditProfileComponent.prototype.editDisplayInline = function (edit) {
        if (edit) {
            return "inline-block";
        }
        else {
            return "none";
        }
    };
    EditProfileComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.showSpinner = true;
        var s9 = this.loginService.usertype().subscribe(function (data) { _this.userTypes = data; _this.userTypeDone = true; console.log("ShowHideLoadingSpinner for userTypeDone"); _this.showHideLoadingSpinner(); }, function (error) {
            _this.userTypeDone = true;
            console.log("ShowHideLoadingSpinner for userTypeDone");
            _this.showHideLoadingSpinner();
            _this.handleError(error);
            _this.skills = false;
        });
        this.subscriptions.push(s9);
        var s10 = this.dashboardService.userSummary1().subscribe(function (data) {
            _this.user = data;
            if (data.countryId != null)
                _this.countryId = data.countryId;
            if (data.city != null)
                _this.city = data.city;
            _this.userSummaryDone = true;
            console.log("ShowHideLoadingSpinner for userSummaryDone");
            _this.showHideLoadingSpinner();
        }, function (error) {
            _this.userSummaryDone = true;
            console.log("ShowHideLoadingSpinner for userSummaryDone");
            _this.showHideLoadingSpinner();
            _this.handleError(error);
            _this.skills = false;
        });
        this.subscriptions.push(s10);
        var s11 = this.dashboardService.editviewProfile().subscribe(function (res) {
            console.log(res);
            _this.initialProfileType = res.profileType;
            _this.userProfileType = res.profileType;
            console.log('userProfileType==>' + _this.userProfileType + "<<");
            _this.viewProfile = res;
            console.log('ngOnInit');
            console.log('this.viewProfile.userEducationSubject==>' + _this.viewProfile.userEducationSubject);
            console.log('this.isAcademicUserTypeDataAvailable==>' + _this.isAcademicUserTypeDataAvailable);
            if (_this.viewProfile.userEducationSubject == null || _this.viewProfile.userEducationSubject == '') {
                _this.isAcademicUserTypeDataAvailable = false;
            }
            console.log('this.isAcademicUserTypeDataAvailable==>' + _this.isAcademicUserTypeDataAvailable);
            _this.myRating = Array(res.noOfRatingStars);
            console.log('myRating');
            console.log(_this.myRating);
            _this.updateeducationalQualification.userType = res.userType;
            _this.updateeducationalQualification.educationalInstitution = res.educationalInstitution;
            _this.updateeducationalQualification.userEducationSubject = res.userEducationSubject;
            _this.updateeducationalQualification.campus = res.campus;
            _this.updatedegreeCourse.userEducationDegreeCourse = res.userEducationDegreeCourse;
            _this.updatelinkedInProfile.linkedInProfile = (res.linkedInProfile != undefined) ? res.linkedInProfile : "";
            _this.editAboutMe.aboutMe = res.aboutMe;
            _this.myInterest.myInterests = res.myInterests;
            _this.editViewProfileDone = true;
            console.log("ShowHideLoadingSpinner for editViewProfileDone");
            _this.showHideLoadingSpinner();
        }, function (error) {
            _this.editViewProfileDone = true;
            console.log("ShowHideLoadingSpinner for editViewProfileDone");
            _this.showHideLoadingSpinner();
            _this.handleError(error);
            _this.skills = false;
        });
        this.subscriptions.push(s11);
        var s12 = this.dashboardService.getSkills()
            .subscribe(function (data) {
            _this.getSkills = data;
            _this.getSkills.forEach(function (val) {
                var skillSetName = (val.userSkillSetName != null && val.userSkillSetName != undefined) ? val.userSkillSetName : val.skillSet.name;
                _this.allskills.push(skillSetName);
            });
            console.log('success');
            console.log(_this.allskills);
            _this.skillsDone = true;
            console.log("ShowHideLoadingSpinner for skillsDone");
            _this.showHideLoadingSpinner();
            // this.eduqloading = false;
        }, function (error) {
            _this.skillsDone = true;
            console.log("ShowHideLoadingSpinner for skillsDone");
            _this.showHideLoadingSpinner();
            _this.handleError(error);
            _this.skills = false;
        });
        this.subscriptions.push(s12);
        var s13 = this.dashboardService.getWorkExp()
            .subscribe(function (data) {
            _this.allwrkExp = [];
            console.log('wexp');
            console.log(data);
            data.forEach(function (element) {
                element.editValue = {};
                if (element.isPresent == "T") {
                    element.wsisPresent = true;
                    element.wspresent = false;
                }
                else {
                    element.wsisPresent = false;
                    element.wspresent = true;
                }
                element.wrkexp = true;
                _this.allwrkExp.push(element);
            });
            if (_this.allwrkExp.length > 0) {
                _this.editWorkexps = new Array(_this.allwrkExp.length);
                _this.isWorkExpDataAvailable = true;
            }
            else {
                _this.isWorkExpDataAvailable = false;
            }
            _this.workExpDone = true;
            console.log("ShowHideLoadingSpinner for workExpDone");
            _this.project = false;
            setTimeout(function () {
                _this.allwrkExp.forEach(function (element) {
                    element.wrkexp = false;
                });
                _this.maximize();
            }, 1000);
            _this.showHideLoadingSpinner();
        }, function (error) {
            _this.workExpDone = true;
            console.log("ShowHideLoadingSpinner for workExpDone");
            _this.showHideLoadingSpinner();
            _this.handleError(error);
            _this.skills = false;
        });
        this.subscriptions.push(s13);
        var s14 = this.dashboardService.getCiRcmd().subscribe(function (data) {
            _this.allcir = data;
            console.log("ShowHideLoadingSpinner for allcir");
            _this.cirDone = true;
            _this.showHideLoadingSpinner();
        }, function (error) {
            _this.cirDone = true;
            console.log("ShowHideLoadingSpinner for allcir");
            _this.showHideLoadingSpinner();
            _this.handleError(error);
            _this.skills = false;
        });
        this.subscriptions.push(s14);
        var s15 = this.dashboardService.getpastEducation()
            .subscribe(function (data) {
            _this.allpastEdu = data;
            console.log('allpastEdu');
            console.log(_this.allpastEdu);
            _this.pastEduDone = true;
            console.log("ShowHideLoadingSpinner for pastEduDone");
            _this.showHideLoadingSpinner();
            // this.eduqloading = false;
        }, function (error) {
            _this.pastEduDone = true;
            console.log("ShowHideLoadingSpinner for pastEduDone");
            _this.showHideLoadingSpinner();
            _this.handleError(error);
            _this.skills = false;
        });
        this.subscriptions.push(s15);
        // let s16 = this.dashboardService.editcourseByMe().subscribe(
        //   res => { console.log(res); this.coursebyMe = res; this.cbmDone = true; console.log("ShowHideLoadingSpinner for cbmDone"); this.showHideLoadingSpinner(); },
        //   error => {
        //     this.cbmDone = true;
        //     console.log("ShowHideLoadingSpinner for cbmDone");
        //     this.showHideLoadingSpinner();
        //     this.handleError(error);
        //     this.skills = false;
        //   }
        // );
        // this.subscriptions.push(s16);
        var s17 = this.dashboardService.userAccptRcmd().subscribe(function (res) {
            _this.userRcmd = res;
            console.log('userRcmd');
            console.log(_this.userRcmd);
            _this.uarDone = true;
            console.log("ShowHideLoadingSpinner for uarDone");
            _this.showHideLoadingSpinner();
        }, function (error) {
            _this.uarDone = true;
            console.log("ShowHideLoadingSpinner for uarDone");
            _this.showHideLoadingSpinner();
            _this.handleError(error);
            _this.skills = false;
        });
        this.subscriptions.push(s17);
    };
    EditProfileComponent.prototype.openSignUpTwoPopup = function (type, profile, work) {
        this.signUpTwoData = {
            userSubType: type,
            userProfile: profile,
            userWork: work
        };
        if (this.user.countryId != null)
            this.countryId = this.user.countryId;
        if (this.user.city != null)
            this.city = this.user.city;
        console.log('1', this.signUpTwoData);
        this.openStep2Popup = true;
    };
    EditProfileComponent.prototype.showHideLoadingSpinner = function () {
        this.showSpinner = !(this.userTypeDone && this.userSummaryDone && this.editViewProfileDone
            && this.skillsDone && this.workExpDone && this.cirDone && this.pastEduDone && this.uarDone);
        console.log("Inside the this.showHideLoadingSpinner() method showSpinner ==>" + this.showSpinner);
    };
    EditProfileComponent.prototype.searchusertypePopup = function (event) {
        this.filterusertypePopup(event.query);
    };
    EditProfileComponent.prototype.filterusertypePopup = function (query) {
        var _this = this;
        this.userService.filterUsertype(query)
            .subscribe(function (data) {
            _this.usertyperesults = data.map(function (userTypeObj) { return userTypeObj.userSubTypeMaster; });
            var previousIsCorporateUser = _this.isCorporateUser;
            _this.checkIfUSerTypeSelectedExistsInUvsity();
            if (previousIsCorporateUser != _this.isCorporateUser) {
                // clear out the edu ins/org title/degree course and campus/location fields
                if (_this.isCorporateUser == true) {
                    _this.userEducation.userEducationEducationInstitution = null; //Edu Institution
                    _this.userEducation.userEducationSubject = null; //Subject
                    _this.userEducation.userEducationCampus = null; //Campus
                    _this.userEducation.userEducationDegreeCourse = null; //Degree Course
                    if (_this.workExpStartDateStartMonth == null || _this.workExpStartDateStartMonth == '') {
                        _this.workExpStartDateStartMonth = _this.frommonths[0].value; //Start Date
                        _this.workExpStartDateStartMonthLabel = _this.frommonths[0].label; //Start Date
                    }
                    if (_this.workExpEndDateStartMonth == null || _this.workExpEndDateStartMonth == '') {
                        _this.workExpEndDateStartMonth = _this.tomonths[0].value;
                        _this.workExpEndDateStartMonthLabel = _this.tomonths[0].label; //Start Date
                    }
                }
                else {
                    _this.userEducation.userEducationEducationInstitution = null; //Organization
                    _this.userEducation.userEducationCampus = null; //Location
                    _this.userEducation.userEducationDegreeCourse = null; // Title / Designation
                    _this.workExpStartDateStartMonth = _this.frommonths[0].value; //Start Date
                    _this.workExpStartDateStartMonthLabel = _this.frommonths[0].label; //Start Date
                    _this.fromYear1 = '';
                    _this.workExpEndDateStartMonth = _this.tomonths[0].value;
                    _this.workExpEndDateStartMonthLabel = _this.tomonths[0].label;
                    _this.toYear1 = '';
                    _this.isPresent = false;
                }
            }
        }, function (error) {
            _this.handleError(error);
        });
    };
    EditProfileComponent.prototype.searcheduinst = function (event) {
        this.filtereduins(event.query);
    };
    EditProfileComponent.prototype.filtereduins = function (query) {
        var _this = this;
        var s18 = this.loginService.filterEduins(query)
            .subscribe(function (data) {
            _this.eduInstresults = data.map(function (eduInsObj) { return eduInsObj.educationalInstitutionFullName; });
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s18);
    };
    EditProfileComponent.prototype.searchcourses = function (event) {
        var _this = this;
        var s19 = this.dashboardService.coursesIRcmd(event.query).subscribe(function (data) {
            _this.CoursesIRcmd = data;
            console.log('CIR');
            console.log(_this.CoursesIRcmd);
            _this.courseIRresults = _this.filtercourse(event.query, _this.CoursesIRcmd);
        }, function (error) {
            _this.handleError(error);
            _this.skills = false;
        });
        this.subscriptions.push(s19);
    };
    EditProfileComponent.prototype.filtercourse = function (query, cIrcmd) {
        //in a real application, make a request to a remote url with the query and return filtered results, for demo we filter at client side
        var filtered = [];
        var repeate_data = [];
        for (var i = 0; i < cIrcmd.length; i++) {
            var courseir = cIrcmd[i];
            console.log(courseir);
            if (courseir.content != null) {
                if (courseir.content.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                    repeate_data.entityId = courseir.entityId;
                    repeate_data.content = courseir.content;
                    filtered.push(repeate_data);
                    repeate_data = [];
                }
            }
        }
        return filtered;
    };
    EditProfileComponent.prototype.courseIrAdd = function () {
        console.log(this.courseiRcmd);
        if (this.courseiRcmd['entityId']) {
            this.cir.push(this.courseiRcmd);
            this.updatecIr();
        }
        this.courseiRcmd = [];
    };
    EditProfileComponent.prototype.deletecir = function (id, type) {
        console.log(id);
        if (type == "new") {
            var index = this.cir.indexOf(id);
            console.log(index);
            if (index !== -1) {
                this.cir.splice(index, 1);
            }
        }
        else if (type == "exist") {
            for (var i in this.allcir) {
                if (this.allcir[i].course.courseId == id) {
                    //delete this.allcir[i];
                    this.allcir.splice(Number(i), 1);
                    break;
                }
            }
        }
        this.updatecIr();
    };
    EditProfileComponent.prototype.updatecIr = function () {
        var _this = this;
        this.pastloading = true;
        var temp = [];
        this.cir.forEach(function (val, ind, arr) {
            temp.push(Number(val.entityId));
        });
        this.allcir.forEach(function (val, ind, arr) {
            temp.push(Number(val.course.courseId));
        });
        console.log(temp);
        var s20 = this.dashboardService.updateCiRcmd(temp).subscribe(function (data) {
            console.log(data);
            _this.allcir = data;
            _this.pastloading = false;
            _this.CorseIR = false;
            _this.courseiRcmd = [];
            _this.cir = [];
        }, function (error) {
            _this.handleError(error);
            _this.skills = false;
        });
        this.subscriptions.push(s20);
    };
    EditProfileComponent.prototype.editpastedu = function (data) {
        console.log(data);
        this.addpastEducation.pastEducationId = data.pastEducationId;
        this.addpastEducation.pastEducationEducationInstitution = data.pastEducationEducationInstitution;
        this.addpastEducation.pastEducationCampus = data.pastEducationCampus;
        this.addpastEducation.educationStartDate = '01/' + this.convertMonth(this.splitDate(data.educationStartDateForDisplay)[0]) + '/' + this.splitDate(data.educationStartDateForDisplay)[1];
        this.addpastEducation.educationEndDate = '01/' + this.convertMonth(this.splitDate(data.educationEndDateForDisplay)[0]) + '/' + this.splitDate(data.educationEndDateForDisplay)[1];
        if (data.isPresent == "T") {
            this.present = false;
            this.addpastEducation.isPresent = "T";
            this.isPresent = true;
        }
        else {
            this.present = true;
            this.addpastEducation.isPresent = "F";
            this.isPresent = false;
        }
        this.addpastEducation.degreeCourse = data.degreeCourse;
        this.addpastEducation.fromMonth = this.convertMonth(this.splitDate(data.educationStartDateForDisplay)[0]);
        this.addpastEducation.fromYear = this.splitDate(data.educationStartDateForDisplay)[1];
        this.addpastEducation.toMonth = this.convertMonth(this.splitDate(data.educationEndDateForDisplay)[0]);
        this.addpastEducation.toYear = this.splitDate(data.educationEndDateForDisplay)[1];
        console.log(this.addpastEducation);
        // this.convertMonth('January')
    };
    EditProfileComponent.prototype.updatePastEdu = function (updatePastEdudata) {
        var _this = this;
        console.log('updatepastedu');
        //console.log(data);
        this.showSpinner = true;
        updatePastEdudata.educationStartDate = updatePastEdudata.fromMonth + '/01/' + updatePastEdudata.fromYear;
        updatePastEdudata.educationEndDate = updatePastEdudata.toMonth + '/01/' + updatePastEdudata.toYear;
        console.log(updatePastEdudata);
        var s21 = this.dashboardService.updatepastEducation(updatePastEdudata)
            .subscribe(function (data) {
            _this.allpastEdu = data;
            console.log('allpastEdu');
            console.log(_this.allpastEdu);
            _this.pastedu = false;
            _this.showSpinner = false;
            updatePastEdudata = {};
        }, function (error) {
            updatePastEdudata = {};
            _this.showSpinner = false;
            _this.handleError(error);
            _this.skills = false;
        });
        this.subscriptions.push(s21);
    };
    EditProfileComponent.prototype.deletePastEducation = function (deletepastedu) {
        var _this = this;
        console.log('deletepastedu');
        //console.log(data);
        this.showSpinner = true;
        deletepastedu.educationStartDate = '01/' + deletepastedu.fromMonth + '/' + deletepastedu.fromYear;
        deletepastedu.educationEndDate = '01/' + deletepastedu.toMonth + '/' + deletepastedu.toYear;
        console.log(deletepastedu);
        var s22 = this.dashboardService.deletepastEducation(deletepastedu)
            .subscribe(function (data) {
            _this.allpastEdu = data;
            console.log('allpastEdu');
            console.log(_this.allpastEdu);
            _this.pastedu = false;
            _this.showSpinner = false;
        }, function (error) {
            _this.showSpinner = false;
            _this.handleError(error);
            _this.skills = false;
        });
        this.subscriptions.push(s22);
    };
    EditProfileComponent.prototype.editdatawrkExp = function (data) {
        data.editValue.projectResearchExpId = data.projectResearchExpId;
        data.editValue.projectResearchExpEducationInsitution = data.projectResearchExpEducationInsitution;
        data.editValue.projectResearchExpCampus = data.projectResearchExpCampus;
        data.editValue.projectResearchStartDate = this.convertMonth(this.splitDate(data.projResearchStartDateForDisplay)[0])
            + '/01' + '/' + this.splitDate(data.projResearchStartDateForDisplay)[1];
        data.editValue.projectResearchEndDate = data.projResearchEndDateForDisplay != null ? this.convertMonth(this.splitDate(data.projResearchEndDateForDisplay)[0])
            + '/01' + '/' + this.splitDate(data.projResearchEndDateForDisplay)[1] : null;
        if (data.isPresent == "T") {
            data.wspresent = false;
            data.editValue.isPresent = "T";
            data.editValue.wsisPresent = true;
        }
        else {
            data.wspresent = true;
            data.editValue.isPresent = "F";
            data.editValue.wsisPresent = false;
        }
        data.editValue.projectResearchDescription = data.projectResearchDescription;
        data.editValue.projectResearchTitle = data.projectResearchTitle;
        data.editValue.fromMonth = this.convertMonth(this.splitDate(data.projResearchStartDateForDisplay)[0]);
        data.editValue.fromYear = this.splitDate(data.projResearchStartDateForDisplay)[1];
        if (data.projResearchEndDateForDisplay != null) {
            data.editValue.toMonth = this.convertMonth(this.splitDate(data.projResearchEndDateForDisplay)[0]);
            data.editValue.toYear = this.splitDate(data.projResearchEndDateForDisplay)[1];
        }
        console.log('Setting the values in the edit section');
        console.log(data.editValue);
        this.frmEditPrResWe.forEach(function (editForm) {
            if (editForm.nativeElement.id == "frmEditPrwe_" + data.projectResearchExpId) {
                console.log('Found the Form that needs to be scrolled into, Id = ' + data.projectResearchExpId + 'form Id=' + editForm.nativeElement.id);
                editForm.nativeElement.scrollIntoView({ behavior: 'smooth' });
            }
        });
    };
    EditProfileComponent.prototype.updateWorkExp = function (data) {
        var _this = this;
        var editedWrkExp = data.editValue;
        if (editedWrkExp.fromMonth == '' && editedWrkExp.fromYear == '' && editedWrkExp.fromMonth == undefined && editedWrkExp.fromYear == undefined) {
            alert('Please Select Start Date');
        }
        else {
            this.addwrkexploading = false;
            this.showSpinner = true;
            editedWrkExp.projectResearchStartDate = editedWrkExp.fromMonth + '/01' + '/' + editedWrkExp.fromYear;
            editedWrkExp.projectResearchEndDate = editedWrkExp.toMonth + '/01' + '/' + editedWrkExp.toYear;
            console.log(editedWrkExp);
            var s23 = this.dashboardService.updateWorkExp(editedWrkExp)
                .subscribe(function (data) {
                _this.allwrkExp = [];
                data.forEach(function (element) {
                    element.editValue = {};
                    if (element.isPresent == 'T') {
                        element.wsisPresent = true;
                        element.wspresent = false;
                    }
                    else {
                        element.wsisPresent = false;
                        element.wspresent = true;
                    }
                    _this.allwrkExp.push(element);
                });
                data.wrkexp = false;
                _this.addwrkexploading = false;
                _this.showSpinner = false;
            }, function (error) {
                _this.showSpinner = false;
                _this.handleError(error);
                _this.skills = false;
            });
            this.subscriptions.push(s23);
        }
    };
    EditProfileComponent.prototype.deleteWorkExp = function (data) {
        var _this = this;
        var editedWrkExp = data.editValue;
        this.addwrkexploading = false;
        this.showSpinner = true;
        editedWrkExp.projectResearchStartDate = editedWrkExp.fromMonth + '/01' + '/' + editedWrkExp.fromYear;
        editedWrkExp.projectResearchEndDate = editedWrkExp.toMonth + '/01' + '/' + editedWrkExp.toYear;
        console.log(editedWrkExp);
        var s24 = this.dashboardService.deleteWorkExp(editedWrkExp)
            .subscribe(function (data) {
            _this.allwrkExp = [];
            data.forEach(function (element) {
                element.editValue = {};
                if (element.isPresent == 'T') {
                    element.wsisPresent = true;
                    element.wspresent = false;
                }
                else {
                    element.wsisPresent = false;
                    element.wspresent = true;
                }
                _this.allwrkExp.push(element);
            });
            if (_this.allwrkExp.length > 0) {
                _this.isWorkExpDataAvailable = true;
            }
            else {
                _this.isWorkExpDataAvailable = false;
            }
            console.log('deletedWrkExpDone');
            console.log(_this.allwrkExp);
            _this.addwrkexploading = false;
            _this.showSpinner = false;
            // this.eduqloading = false;
        }, function (error) {
            _this.showSpinner = false;
            _this.handleError(error);
            _this.skills = false;
        });
        this.subscriptions.push(s24);
    };
    EditProfileComponent.prototype.updateEditRcmd = function (userRcmd) {
        var _this = this;
        console.log('updateusrrcmd');
        console.log(userRcmd);
        this.userRcmdloading = true;
        var s25 = this.dashboardService.updateuserAccptRcmd(userRcmd).subscribe(function (data) {
            _this.userRcmdloading = false;
        }, function (error) {
            _this.userRcmdloading = false;
            _this.handleError(error);
            _this.skills = false;
        });
        this.subscriptions.push(s25);
    };
    EditProfileComponent.prototype.splitDate = function (date) {
        var res = date.split(" ");
        return res;
    };
    EditProfileComponent.prototype.convertMonth = function (mon) {
        var month = '01';
        switch (mon) {
            case 'January':
                month = '01';
                break;
            case 'February':
                month = '02';
                break;
            case 'March':
                month = '03';
                break;
            case 'April':
                month = '04';
                break;
            case 'May':
                month = '05';
                break;
            case 'June':
                month = '06';
                break;
            case 'July':
                month = '07';
                break;
            case 'August':
                month = '08';
                break;
            case 'September':
                month = '09';
                break;
            case 'October':
                month = '10';
                break;
            case 'November':
                month = '11';
                break;
            case 'December':
                month = '12';
                break;
        }
        return month;
    };
    EditProfileComponent.prototype.handleError = function (error) {
        console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.errorHandlerService.throwError(error);
    };
    EditProfileComponent.prototype.changeProfileType = function (profType) {
        var _this = this;
        if (this.allwrkExp != null && this.allwrkExp.length > 0) {
            this.allwrkExp[0].wrkexp = false;
        }
        this.profileclg = false;
        this.project = false;
        console.log("Begin changeProfileType");
        console.log("isProfileChangeRequired==>" + isProfileChangeRequired);
        console.log("isAcademicUserTypeDataAvailable==>" + this.isAcademicUserTypeDataAvailable);
        console.log("isProfileTypeChangeRequiredAfterAcademicUserTypeAdd==>" + this.isProfileTypeChangeRequiredAfterAcademicUserTypeAdd);
        var isProfileChangeRequired = false;
        this.userProfileType = profType;
        if (profType == 'Professional') {
            if (this.isWorkExpDataAvailable == true) {
                isProfileChangeRequired = true;
            }
            else {
                isProfileChangeRequired = false;
                this.isProfileTypeChangeRequiredAfterProjResExpAdd = true;
                this.project = true;
                this.frmAddPrwe.nativeElement.scrollIntoView({ behavior: 'smooth' });
                this.createInfoAlert("Please add at least one Project/Research/Work Experience in order to change your profile type to 'Professional'.");
            }
        }
        else {
            isProfileChangeRequired = true;
            if (this.isAcademicUserTypeDataAvailable == false) {
                this.isProfileTypeChangeRequiredAfterAcademicUserTypeAdd = true;
                isProfileChangeRequired = false;
                this.profileclg = true;
                this.frmProfile.nativeElement.scrollIntoView({ behavior: 'smooth' });
                this.createInfoAlert("Please enter your educational qualification in order to change your profile type to 'Academic'.");
            }
        }
        console.log("changeProfileType: After IF-Else-Before Service Call");
        console.log("isProfileChangeRequired==>" + isProfileChangeRequired);
        console.log("isAcademicUserTypeDataAvailable==>" + this.isAcademicUserTypeDataAvailable);
        console.log("isProfileTypeChangeRequiredAfterAcademicUserTypeAdd==>" + this.isProfileTypeChangeRequiredAfterAcademicUserTypeAdd);
        if (isProfileChangeRequired == true) {
            this.showSpinner = true;
            var profileData = { profileType: this.userProfileType };
            var s26 = this.dashboardService.updateUserProfileType(profileData).subscribe(function (data) {
                // Need to update the profile data so that the user type gets Changed
                _this.dashboardService.editviewProfile().subscribe(function (res) {
                    console.log(res);
                    _this.updateeducationalQualification.userType = res.userType;
                    _this.updateeducationalQualification.educationalInstitution = res.educationalInstitution;
                    _this.viewProfile = res;
                    _this.showSpinner = false;
                }, function (error) {
                    _this.handleError(error);
                });
                _this.createInfoAlert('User Profile Type Changed Successfully!!');
            }, function (error) {
                _this.handleError(error);
            });
            this.subscriptions.push(s26);
        }
    };
    EditProfileComponent.prototype.ngAfterViewInit = function () {
        this.maximize();
    };
    EditProfileComponent.prototype.maximize = function () {
        var that = this;
        setTimeout(function () {
            $(".e-maximize").on("click", function () {
                $(this).parents("ejs-richtexteditor").addClass("zIndex");
                that.minimize();
            });
        }, 1000);
    };
    EditProfileComponent.prototype.minimize = function () {
        var that = this;
        setTimeout(function () {
            $(".e-minimize").on("click", function () {
                $(this).parents("ejs-richtexteditor").removeClass("zIndex");
                that.maximize();
                setTimeout(function () {
                    $(".e-nav-active").trigger("click");
                }, 500);
            });
        }, 1000);
    };
    EditProfileComponent.prototype.checkIfUSerTypeSelectedExistsInUvsity = function () {
        this.isCorporateUser = true;
        if (this.usertyperesults != null && this.usertyperesults.length) {
            if (this.usertyperesults.length > 0) {
                this.isCorporateUser = false;
            }
        }
    };
    EditProfileComponent.prototype.updateUser = function (e) {
        var _this = this;
        this.signUpTwoData = null;
        if (e) {
            var userSubscription = this.dashboardService.editviewProfile().subscribe(function (res) {
                console.log(res);
                _this.initialProfileType = res.profileType;
                _this.userProfileType = res.profileType;
                console.log('userProfileType==>' + _this.userProfileType + "<<");
                _this.viewProfile = res;
                console.log('ngOnInit');
                console.log('this.viewProfile.userEducationSubject==>' + _this.viewProfile.userEducationSubject);
                console.log('this.isAcademicUserTypeDataAvailable==>' + _this.isAcademicUserTypeDataAvailable);
                if (_this.viewProfile.userEducationSubject == null || _this.viewProfile.userEducationSubject == '') {
                    _this.isAcademicUserTypeDataAvailable = false;
                }
                console.log('this.isAcademicUserTypeDataAvailable==>' + _this.isAcademicUserTypeDataAvailable);
                _this.myRating = Array(res.noOfRatingStars);
                console.log('myRating');
                console.log(_this.myRating);
                _this.updateeducationalQualification.userType = res.userType;
                _this.updateeducationalQualification.educationalInstitution = res.educationalInstitution;
                _this.updateeducationalQualification.userEducationSubject = res.userEducationSubject;
                _this.updateeducationalQualification.campus = res.campus;
                _this.updatedegreeCourse.userEducationDegreeCourse = res.userEducationDegreeCourse;
                _this.editAboutMe.aboutMe = res.aboutMe;
                _this.myInterest.myInterests = res.myInterests;
                _this.editViewProfileDone = true;
                console.log("ShowHideLoadingSpinner for editViewProfileDone");
                _this.showHideLoadingSpinner();
                _this.openStep2Popup = false;
            }, function (error) {
                _this.editViewProfileDone = true;
                console.log("ShowHideLoadingSpinner for editViewProfileDone");
                _this.showHideLoadingSpinner();
                _this.handleError(error);
                _this.skills = false;
                _this.openStep2Popup = false;
            });
            this.subscriptions.push(userSubscription);
            var we = this.dashboardService.getWorkExp()
                .subscribe(function (data) {
                _this.allwrkExp = [];
                console.log('wexp');
                console.log(data);
                data.forEach(function (element) {
                    element.editValue = {};
                    if (element.isPresent == "T") {
                        element.wsisPresent = true;
                        element.wspresent = false;
                    }
                    else {
                        element.wsisPresent = false;
                        element.wspresent = true;
                    }
                    _this.allwrkExp.push(element);
                });
                if (_this.allwrkExp.length > 0) {
                    _this.editWorkexps = new Array(_this.allwrkExp.length);
                    _this.isWorkExpDataAvailable = true;
                }
                else {
                    _this.isWorkExpDataAvailable = false;
                }
                _this.workExpDone = true;
                console.log("ShowHideLoadingSpinner for workExpDone");
                _this.showHideLoadingSpinner();
            }, function (error) {
                _this.workExpDone = true;
                console.log("ShowHideLoadingSpinner for workExpDone");
                _this.showHideLoadingSpinner();
                _this.handleError(error);
                _this.skills = false;
            });
            this.subscriptions.push(we);
        }
        else {
            this.openStep2Popup = false;
        }
    };
    EditProfileComponent.prototype.closeErrorPopup = function () {
        console.log("After closing Error Popup");
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorModalDialog = false;
        this.showErrorMessages = [];
    };
    EditProfileComponent.prototype.createInfoAlert = function (alert) {
        var infoAlert = {
            isInfo: true,
            infoMessage: alert,
            url: "not required"
        };
        this.handleError(infoAlert);
    };
    EditProfileComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (element) {
            element.unsubscribe();
        });
    };
    return EditProfileComponent;
}());
export { EditProfileComponent };
//# sourceMappingURL=editProfile.component.js.map